import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options';
import Keyboard from './keyboard';

export const PLUGIN_NAME = 'sideCart';
export const CLICK_EVENT = 'click';
export const SIDEPANEL_OPEN = 'side-panel--open';
export const BAG_SIDEBAR_ID = '#js-side-panel';
export const BAG_CLOSE_ID = '#js-side-panel-close';
export const BAG_ICON = '#js-bag-btn';
const BAG_CLOSE_AND_CONTINUE_SHOP = '#js-side-panel-close, #btn-continue-shopping';
const BAG_WRAPPER = '#js-side-panel__wrapper';

export const DEFAULTS = {

};

const closeSideCart = (flag) => {
  if (flag === true) {
    if ($(BAG_SIDEBAR_ID).hasClass(SIDEPANEL_OPEN)) {
      $(BAG_SIDEBAR_ID).removeClass(SIDEPANEL_OPEN);
      $('.side-panel--right').on('transitionend webkitTransitionEnd oTransitionEnd', () => {
        $('.side-panel--right').off('transitionend webkitTransitionEnd oTransitionEnd');
        $(BAG_SIDEBAR_ID).hide(1000);
      });
      $(BAG_SIDEBAR_ID).attr('aria-modal', 'false');
    }
  } else {
    // eslint-disable-next-line
    if (!$(BAG_SIDEBAR_ID).hasClass(SIDEPANEL_OPEN)) {
      $(BAG_SIDEBAR_ID).show(() => {
        $(BAG_SIDEBAR_ID).addClass(SIDEPANEL_OPEN);
      });
      $(BAG_SIDEBAR_ID).attr('aria-modal', 'true');
    }
  }
};

const setEventListeners = ($el) => {
  let SHOP_BAG_CLICK = false;

  /* Fire on shopping-bag icon click */
  $el.on(CLICK_EVENT, (e) => {
    e.preventDefault();
    e.stopPropagation();
    SHOP_BAG_CLICK = true;
    closeSideCart(false);
    Keyboard.trapFocus($(BAG_SIDEBAR_ID));
    if ($(BAG_CLOSE_ID).length > 0) {
      $(BAG_CLOSE_ID).attr('tabindex', '0').focus();
    }
    if (typeof window.PAGE_TRACK_A_MODULE !== 'undefined' && $.isFunction(window.PAGE_TRACK_A_MODULE.insertEventTrack)) {
      window.PAGE_TRACK_A_MODULE.insertEventTrack('shopping_bag', 'view_item');
    }
  });

  /* Fire on ENTER keypress of side-cart close icon or continue-shopping button (empty cart) */
  $(BAG_SIDEBAR_ID).on(CLICK_EVENT, BAG_CLOSE_AND_CONTINUE_SHOP, (e) => {
    e.preventDefault();
    e.stopPropagation();
    Keyboard.releaseFocus($(BAG_SIDEBAR_ID), $el);
    closeSideCart(true);
    SHOP_BAG_CLICK = false;
  });

  /* Fire on append of new side-cart HTML - re-attach listener */
  $(BAG_WRAPPER).on(CLICK_EVENT, BAG_CLOSE_AND_CONTINUE_SHOP, (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (SHOP_BAG_CLICK === true) {
      Keyboard.releaseFocus($(BAG_SIDEBAR_ID), $el);
      SHOP_BAG_CLICK = false;
    } else {
      Keyboard.releaseFocus($(BAG_SIDEBAR_ID), $('#addToBagBtn button, #preorderBtn button'));
    }
    closeSideCart(true);
  });

  /* Fire on click outside #js-side-panel, close side-cart */
  $('body').on('click.js-bag-btn', (e) => {
    if ($(e.target).parents(BAG_SIDEBAR_ID).length === 0) {
      closeSideCart(true);
      SHOP_BAG_CLICK = false;
    }
  });

  /* Fire on ESC, close side-cart */
  $(document).on('keyup', (e) => {
    if (e.key === 'Escape' || e.keyCode === 27) {
      if (SHOP_BAG_CLICK === true) {
        Keyboard.releaseFocus($(BAG_SIDEBAR_ID), $el);
        SHOP_BAG_CLICK = false;
      } else {
        Keyboard.releaseFocus($(BAG_SIDEBAR_ID), $('#addToBagBtn button, #preorderBtn button'));
      }
      closeSideCart(true);
    }
  });

  /* Fire after append of new items. */
  const shoppingBagNode = $(BAG_WRAPPER)[0];
  const obsConfig = { childList: true, subtree: true };
  const shoppingBagObserver = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      if (mutation.type === 'childList') {
        Keyboard.trapFocus($(BAG_SIDEBAR_ID));
      }
    });
  });
  if (shoppingBagNode instanceof Node) {
    shoppingBagObserver.observe(shoppingBagNode, obsConfig);
  }
};

export default function sideCart(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);
  setEventListeners($el, opts);
}

registerJQueryPlugin(PLUGIN_NAME, sideCart);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/side-cart.js